import { cn } from '#app/utils/misc.tsx'

export type FeatureItem = {
	heading: string
	body: string
	number?: string
}

export function FeatureRow({
	items,
	variant = 'cards',
	className,
}: {
	items: FeatureItem[]
	variant?: 'cards' | 'numbered'
	className?: string
}) {
	if (variant === 'numbered') {
		return (
			<ul className={cn('flex flex-col gap-8', className)}>
				{items.map((item, i) => (
					<li
						key={i}
						className="grid grid-cols-[3rem_1fr] gap-4 border-t border-m-rule pt-6 first:border-t-0 first:pt-0"
					>
						<span className="font-mono-display text-mono-label text-ember">
							{item.number ?? String(i + 1).padStart(2, '0')}
						</span>
						<div>
							<h3 className="font-display text-display-3">{item.heading}</h3>
							<p className="mt-2 text-base leading-relaxed text-ink-fg-soft">
								{item.body}
							</p>
						</div>
					</li>
				))}
			</ul>
		)
	}
	return (
		<div className={cn('grid gap-6 md:grid-cols-3', className)}>
			{items.map((item, i) => (
				<div
					key={i}
					className="rounded-lg border border-m-rule bg-ink-soft p-6"
				>
					<h3 className="font-display text-display-3">{item.heading}</h3>
					<p className="mt-2 text-base leading-relaxed text-ink-fg-soft">
						{item.body}
					</p>
				</div>
			))}
		</div>
	)
}
